import wordDensityApi from '../../api/word.density.api'

const state = {
    url: '',
    token: '',
    type: 0 // 类型0：文字，1：图片
};

const getters = {
};

const mutations = {
    setState(state, data) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                state[key] = data[key];
            }
        }
    }
};

const actions = {
    startSingle({state, commit}, params) {
        return wordDensityApi.startSingle(params).then(res => {
            commit('setState', {url: params.url, token: res._id});
            return res;
        })
    },
    //获取进度数据
    getProgress({state},parmas) {
        return wordDensityApi.progress(parmas);
    },
    downloadReport({state}) {
        return wordDensityApi.downloadReport({token:state.token});
    },
    getFilterList({state},params) {
        return wordDensityApi.getFilterList(params);
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/wordDensity.js